import _isArray from "lodash/isArray";
import _maxBy from "lodash/maxBy";
import { TOW } from "../app-consts/appConstants";

export const getCommonBenefits = (state) => state.commonBenefits;

export const getCommonBenefitsStatus = (state) =>
  state.commonBenefits?.status?.toUpperCase?.() || "";

export const getCustomerType = (state) => state?.commonBenefits.customerType;

export const getExpirationMileageByIndex = (state, index) => {
  const commonBenefits = getCommonBenefits(state);
  if (
    !commonBenefits?.vehicles ||
    !_isArray(commonBenefits.vehicles) ||
    commonBenefits.vehicles.length <= 0
  ) {
    return 0;
  }
  if (!commonBenefits.vehicles[index].expirationMileage) {
    return 0;
  }
  return commonBenefits.vehicles[index].expirationMileage;
};

export const getLastKnownMileageByIndex = (state, index) => {
  const commonBenefits = getCommonBenefits(state);
  if (
    !commonBenefits?.vehicles ||
    !_isArray(commonBenefits.vehicles) ||
    commonBenefits.vehicles.length <= 0
  ) {
    return 0;
  }
  const mileage = commonBenefits.vehicles[index].lastKnownMileage;
  return mileage != null ? mileage : 0;
};

export const getTowCoverages = (state) =>
  state.commonBenefits?.services?.find((service) => service.type === TOW)
    ?.coverages || [];

export const hasBenefitsSelector = (state) =>
  state.partnerDetails.partnerDetails.experience?.benefitsEnabled &&
  state.commonBenefits.benefits;

export const isPayPerUseSelector = (state) =>
  (state.commonBenefits?.noBenefits &&
    state.partnerDetails.partnerDetails.experience?.ppuEnabled) ||
  (state.partnerDetails.partnerDetails.experience?.ppuEnabled &&
    !state.partnerDetails.partnerDetails.experience?.benefitsEnabled);

export const getBenefitsOperator = (state) =>
  state.commonBenefits?.operators || [];

export const getHomeOperatorAddress = (state) => {
  const operators = getBenefitsOperator(state);
  if (!_isArray(operators) || operators.length === 0) {
    return {};
  }

  const homeOperator = operators.find(
    (operator) => operator?.address?.addressType?.toLowerCase?.() === "home"
  );

  return homeOperator?.address || {};
};

export const getTowServiceDetails = (state) => state.commonBenefits?.services?.find((service) => service.type === TOW);

export const getCallIdFromCommonBenefits = (state) => state.commonBenefits?.callId || "";

export const getHighestCoverageVehicle = (state) => {
  const vehicles = state.commonBenefits?.vehicles;
  if (!vehicles || !_isArray(vehicles) || vehicles.length === 0) {
    return undefined;
  }
  const activeVehicles = vehicles.filter((vehicle) => vehicle.suspendIndicator !== 'Y' && !!vehicle.promotionCode);
  if (activeVehicles.length === 0) {
    return undefined;
  }
  return _maxBy(activeVehicles, (vehicle) => parseFloat(vehicle.coverageAmount));
};

export const getTowToLocationType = (state) => state.commonBenefits?.experience?.towToLocationType;

export const getTowToEnabled = (state) => state.commonBenefits?.experience?.towToEnabled;

export const getCustomDestinationEnabled = (state) => state.commonBenefits?.experience?.customDestinationEnabled;

export const getTowToLocationSearch = (state) => state.commonBenefits?.experience?.towToLocationSearch;

export const getSupportedRegions = (state) => state.commonBenefits?.experience?.supportedRegions;

export const getPassThruEnabled = (state) => state.commonBenefits?.experience?.passThruEnabled;
